import { ClientMessaging } from '../../../components/ClientMessaging/ClientMessaging';
import { useAppSelector } from '../../../store/store';
import { UserModel } from '../../../store/user/userModel';

export default function ClientMessagingPage() {
  const user: UserModel = useAppSelector((state: any) => state.user.user);
  return <ClientMessaging currentUserId={user.id || ''} />;
}
